module.exports = __webpack_public_path__ + "img/nav-covid-light.d2c0d91d.svg";